// extracted by mini-css-extract-plugin
export default {"page":"wZ-z","cartModal":"xZ-z","checkout":"yZ-z","placeholder":"zZ-z","account":"AZ-z"};